import React, { useState,useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { useNavigate, useLocation} from 'react-router-dom';
import { Spinner } from '../Loader/Loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faExclamationTriangle, faTrash, faX, faPlusCircle, faChevronDown, faSearch } from '@fortawesome/free-solid-svg-icons';

/* const operators = [
  { label: "Equal", value: "==" },
  { label: "Not Equal", value: "!=" },
  { label: "Greater Than", value: ">" },
  { label: "Greater Than or Equal", value: ">=" },
  { label: "Less Than", value: "<" },
  { label: "Less Than or Equal", value: "<=" },
]; */

const operators = [
  // Basic comparison
  { label: "is", value: "==" },
  { label: "is not", value: "!=" },
  { label: "is greater than", value: ">" },
  { label: "is greater than or equal to", value: ">=" },
  { label: "is less than", value: "<" },
  { label: "is less than or equal to", value: "<=" },
  
  // Text operations
  { label: "contains", value: "contains" },
  { label: "does not contain", value: "not_contains" },
  { label: "starts with", value: "starts_with" },
  { label: "ends with", value: "ends_with" },
  
  // Existence checks
  { label: "is empty", value: "is_empty" },
  { label: "is not empty", value: "is_not_empty" },
  { label: "exists", value: "exists" },
  { label: "does not exist", value: "not_exists" },
  
  // Array/List operations
  { label: "is in", value: "in" },
  { label: "is not in", value: "not_in" },
  { label: "includes any of", value: "includes_any" },
  { label: "includes all of", value: "includes_all" },
  
  // Date operations
  { label: "is before", value: "before" },
  { label: "is after", value: "after" },
  { label: "is between", value: "between" },
  
  // Pattern matching
  { label: "matches pattern", value: "regex" },
  { label: "is like", value: "like" }
];

export default function EditRule({rewardRuleData }) {
  const location = useLocation();
  const ruleData  = /* location.state.rewardRuleData */rewardRuleData  || {};
console.log("Location State:", location.state);
  //console.log("Rule Data:", ruleData);

  const [isDirty, setIsDirty] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [errors, setErrors] = useState({});
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [locations, setLocations] = useState([]);

  const fields = [
    { label: "Category", value: "category", type: "select", options: categories },
    { label: "Brand", value: "brand", type: "select", options: brands },
    { label: "Amount", value: "amount" },
    { label: "Is Ecommerce", value: "is_ecommerce", type: "select", options: [
      { id: "true", name: "Yes" },
      { id: "false", name: "No" }
    ]},
    { label: "Campaign", value: "campaign" },
    { label: "Event", value: "event" },
    { label: "Location", value: "location", type: "multiselect", options: locations },
    { label: "Items", value: "items", type: "multiselect", options: items },
  ];

  // Updated to match new schema - rewardCriteria as array
  const [rewardCriteria, setRewardCriteria] = useState([
    {
      id: uuidv4(), 
      name: "",
      fromDate: "",
      toDate: "",
      conditions: []
    }
  ]); 
  
  const [rewardRules, setRewardRules] = useState([
    { 
      id: uuidv4(), 
      name: "", 
      rewardType: "fixed", 
      rewardValue: 0, 
      applyTarget: "order",
      destination: "wallet",
      limit: 0,
      applicableItems: []
    }
  ]);
  
  const [applicabilityRules, setApplicabilityRules] = useState([
    { id: uuidv4(), name: "", conditions: [] }
  ]);
  
  // Updated redemptionRules to match new schema
  const [redemptionRules, setRedemptionRules] = useState([
    { 
      id: uuidv4(), 
      name: "", 
      redeemType: "percentage", 
      redeemValue: 0,
      applyTarget: "order"
    }
  ]);

  // Updated expiryRules to match new schema
  const [expiryRules, setExpiryRules] = useState([
    { 
      id: uuidv4(), 
      name: "", 
      expiryType: "days",
      expiryValue: 60, 
      conditions: [] 
    }
  ]);

    // Searchable Single Select Dropdown Component
    const SearchableDropdown = ({ options, value, onChange, placeholder, disabled = false }) => {
      const [isOpen, setIsOpen] = useState(false);
      const [searchTerm, setSearchTerm] = useState('');
  
      const filteredOptions = options.filter(option =>
        option.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
  
      const selectedOption = options.find(opt => opt.name === value);
  
      const handleSelect = (option) => {
        onChange(option.name);
        setIsOpen(false);
        setSearchTerm('');
      };
  
      return (
        <div className="relative flex-1">
          <div
            className={`border border-gray-300 p-1 rounded-md cursor-pointer bg-white flex justify-between items-center min-h-[40px] ${
              disabled ? 'bg-gray-100 cursor-not-allowed' : ''
            }`}
            onClick={() => !disabled && setIsOpen(!isOpen)}
          >
            <span className={!selectedOption ? "text-gray-500" : "text-gray-900"}>
              {selectedOption ? selectedOption.name : placeholder}
            </span>
            <FontAwesomeIcon 
              icon={faChevronDown} 
              className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}
            />
          </div>
          
          {isOpen && !disabled && (
            <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-hidden">
              <div className="p-1 border-b border-gray-200">
                <div className="relative">
                  <FontAwesomeIcon 
                    icon={faSearch} 
                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                  />
                  <input
                    type="text"
                    className="w-full pl-10 pr-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              </div>
              <div className="max-h-48 overflow-y-auto">
                {filteredOptions.length > 0 ? (
                  filteredOptions.map((option) => (
                    <div
                      key={option.id}
                      className="p-1 hover:bg-gray-100 cursor-pointer"
                      onClick={() => handleSelect(option)}
                    >
                      {option.name}
                    </div>
                  ))
                ) : (
                  <div className="p-1 text-gray-500">No options found</div>
                )}
              </div>
            </div>
          )}
        </div>
      );
    };
  
  
  
  // Multi-select component for locations with search - PROPERLY FIXED VERSION
  const MultiSelectDropdown = ({ options, selectedValues, onChange, placeholder }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
  
    const filteredOptions = options.filter(option =>
      option.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    const handleOptionToggle = (optionId, event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      
      let newSelectedValues;
      
      if (optionId === "all") {
        // If "All" is selected, select all individual options (excluding "all" itself)
        if (selectedValues.includes("all") || isAllIndividualItemsSelected()) {
          // If "All" is currently selected or all individual items are selected, deselect everything
          newSelectedValues = [];
        } else {
          // Select all individual options (excluding "all")
          const individualOptions = options.filter(opt => opt.id !== "all");
          newSelectedValues = individualOptions.map(option => option.id);
        }
      } else {
        // Handle individual option selection
        if (selectedValues.includes(optionId)) {
          newSelectedValues = selectedValues.filter(id => id !== optionId);
        } else {
          newSelectedValues = [...selectedValues, optionId];
        }
        
        // Remove "all" if it was somehow in the array
        newSelectedValues = newSelectedValues.filter(id => id !== "all");
      }
      
      onChange(newSelectedValues);
    };
  
    // Helper function to check if all individual items are selected
    const isAllIndividualItemsSelected = () => {
      const individualOptions = options.filter(opt => opt.id !== "all");
      const selectedIndividualOptions = selectedValues.filter(id => id !== "all");
      return selectedIndividualOptions.length === individualOptions.length && individualOptions.length > 0;
    };
  
    const getDisplayText = () => {
      if (selectedValues.length === 0) return placeholder || "Select items";
      
      // Check if all individual options are selected
      if (isAllIndividualItemsSelected()) {
        return "All items selected";
      }
      
      if (selectedValues.length === 1) {
        const option = options.find(opt => opt.id === selectedValues[0]);
        return option ? option.name : "";
      }
      return `${selectedValues.length} items selected`;
    };
  
    // Close dropdown when clicking outside
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (isOpen && !event.target.closest('.multiselect-dropdown')) {
          setIsOpen(false);
          setSearchTerm('');
        }
      };
  
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isOpen]);
  
    const handleDropdownToggle = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsOpen(!isOpen);
    };
  
    const handleDropdownContentClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
  
    return (
      <div className="relative flex-1 multiselect-dropdown">
        <div
          className="border border-gray-300 p-1 rounded-md cursor-pointer bg-white flex justify-between items-center min-h-[32px]"
          onClick={handleDropdownToggle}
        >
          <span className={selectedValues.length === 0 ? "text-gray-500" : "text-gray-900"}>
            {getDisplayText()}
          </span>
          <FontAwesomeIcon 
            icon={faChevronDown} 
            className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}
          />
        </div>
        
        {isOpen && (
          <div 
            className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-hidden"
            onClick={handleDropdownContentClick}
          >
            {/* Search Input Section */}
            <div className="p-1 border-b border-gray-200 bg-gray-50">
              <div className="relative">
                <FontAwesomeIcon 
                  icon={faSearch} 
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"
                />
                <input
                  type="text"
                  className="w-full pl-10 p-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                  placeholder="Search ..."
                  value={searchTerm}
                  onChange={(e) => {
                    e.stopPropagation();
                    setSearchTerm(e.target.value);
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
                {searchTerm && (
                  <button
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setSearchTerm('');
                    }}
                  >
                    <FontAwesomeIcon icon={faX} className="text-xs" />
                  </button>
                )}
              </div>
            </div>
            
            {/* Options List */}
            <div className="max-h-48 overflow-y-auto">
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => {
                  // Determine if this option should be checked
                  const isChecked = option.id === "all" 
                    ? isAllIndividualItemsSelected() 
                    : selectedValues.includes(option.id);
  
                  return (
                    <label
                      key={option.id}
                      className="flex items-center p-1 hover:bg-gray-100 cursor-pointer transition-colors"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => handleOptionToggle(option.id, e)}
                        onClick={(e) => e.stopPropagation()}
                        className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer"
                      />
                      <span className="text-sm text-gray-900 cursor-pointer select-none flex-1">
                        {option.name}
                      </span>
                    </label>
                  );
                })
              ) : (
                <div className="px-2 py-3 text-gray-500 text-sm text-center">
                  {searchTerm ? `No items found for "${searchTerm}"` : 'No items available'}
                </div>
              )}
            </div>
            
            {/* Footer with selection count and buttons */}
            <div className="p-1 border-t border-gray-200 bg-gray-50">
              <div className="flex justify-between items-center text-xs text-gray-600">
                <span>{selectedValues.length} selected</span>
                <div className="flex gap-2">
                  <button
                    className="text-blue-600 hover:text-blue-800 font-medium"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onChange([]);
                    }}
                  >
                    Clear All
                  </button>
                  <button
                    className="bg-blue-600 hover:bg-blue-700 text-white px-2 py-1 rounded text-xs font-medium"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setIsOpen(false);
                      setSearchTerm('');
                    }}
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };
  
  
  // Make sure you have the updateRewardRuleApplicableItems function (add this if missing)
const updateRewardRuleApplicableItems = (ruleId, selectedValues) => {
  // Convert selected IDs to objects with id and name
  const selectedItems = selectedValues.map(itemId => {
    const item = items.find(item => item.id === itemId);
    return item ? { id: item.id, name: item.name } : null;
  }).filter(Boolean);

  setRewardRules(prev => 
    prev.map(rule => {
      if (rule.id === ruleId) {
        const updatedRule = { ...rule, applicableItems: selectedItems };
        // Auto-generate name if it's empty or default
        if (!updatedRule.name || updatedRule.name === "" || updatedRule.name === "New Reward Rule" || updatedRule.name.includes("Give ")) {
          updatedRule.name = generateRewardRuleName(updatedRule);
        }
        return updatedRule;
      }
      return rule;
    })
  );
  setIsDirty(true);
};
  
     // Searchable Dropdown for Operators
    const OperatorDropdown = ({ value, onChange }) => {
      const [isOpen, setIsOpen] = useState(false);
      const [searchTerm, setSearchTerm] = useState('');
  
      const filteredOperators = operators.filter(op =>
        op.label.toLowerCase().includes(searchTerm.toLowerCase())
      );
  
      const selectedOperator = operators.find(op => op.value === value);
  
      const handleSelect = (operator) => {
        onChange(operator.value);
        setIsOpen(false);
        setSearchTerm('');
      };
  
      return (
        <div className="relative flex-1">
          <div
            className="border border-gray-300 p-1 rounded-md cursor-pointer bg-white flex justify-between items-center min-h-[32px]"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className={!selectedOperator ? "text-gray-500" : "text-gray-900"}>
              {selectedOperator ? selectedOperator.label : "Select Operator"}
            </span>
            <FontAwesomeIcon 
              icon={faChevronDown} 
              className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}
            />
          </div>
          
          {isOpen && (
            <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-hidden">
              <div className="p-1 border-b border-gray-200">
                <div className="relative">
                  <FontAwesomeIcon 
                    icon={faSearch} 
                    className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400"
                  />
                  <input
                    type="text"
                    className="w-full pl-10 p-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Search operators..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              </div>
              <div className="max-h-48 overflow-y-auto">
                {filteredOperators.length > 0 ? (
                  filteredOperators.map((operator) => (
                    <div
                      key={operator.value}
                      className="p-1 hover:bg-gray-100 cursor-pointer"
                      onClick={() => handleSelect(operator)}
                    >
                      {operator.label}
                    </div>
                  ))
                ) : (
                  <div className="p-1 text-gray-500">No operators found</div>
                )}
              </div>
            </div>
          )}
        </div>
      );
    };
  
    // Searchable Dropdown for Fields
    const FieldDropdown = ({ value, onChange }) => {
      const [isOpen, setIsOpen] = useState(false);
      const [searchTerm, setSearchTerm] = useState('');
  
      const filteredFields = fields.filter(field =>
        field.label.toLowerCase().includes(searchTerm.toLowerCase())
      );
  
      const selectedField = fields.find(f => f.value === value);
      const handleSelect = (field) => {
        onChange(field.value);
        setIsOpen(false);
        setSearchTerm('');
      };
  
      return (
        <div className="relative flex-1">
          <div
            className="border border-gray-300 p-1 rounded-md cursor-pointer bg-white flex justify-between items-center min-h-[32px]"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className={!selectedField ? "text-gray-500" : "text-gray-900"}>
              {selectedField ? selectedField.label : "Select Field"}
            </span>
            <FontAwesomeIcon 
              icon={faChevronDown} 
              className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}
            />
          </div>
          
          {isOpen && (
            <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-hidden">
              <div className="p-1 border-b border-gray-200">
                <div className="relative">
                  <FontAwesomeIcon 
                    icon={faSearch} 
                    className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400"
                  />
                  <input
                    type="text"
                    className="w-full pl-10 p-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Search fields..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              </div>
              <div className="max-h-32 overflow-y-auto">
                {filteredFields.length > 0 ? (
                  filteredFields.map((field) => (
                    <div
                      key={field.value}
                      className="p-1 hover:bg-gray-100 cursor-pointer"
                      onClick={() => handleSelect(field)}
                    >
                      {field.label}
                    </div>
                  ))
                ) : (
                  <div className="p-1 text-gray-500">No fields found</div>
                )}
              </div>
            </div>
          )}
        </div>
      );
    };

const updateRewardCriteriaFromDate = (criteriaId, fromDate) => {
  setRewardCriteria(prev => 
    prev.map(criteria => {
      if (criteria.id === criteriaId) {
        const updatedCriteria = { ...criteria, fromDate };
        // Auto-generate name if it's empty or default
        if (!updatedCriteria.name || updatedCriteria.name === "" || updatedCriteria.name === "New Reward Criteria" || updatedCriteria.name.includes("Rule applies") || updatedCriteria.name.includes("When ")) {
          updatedCriteria.name = generateRewardCriteriaName(updatedCriteria);
        }
        return updatedCriteria;
      }
      return criteria;
    })
  );
  setIsDirty(true);
};

const updateRewardCriteriaToDate = (criteriaId, toDate) => {
  setRewardCriteria(prev => 
    prev.map(criteria => {
      if (criteria.id === criteriaId) {
        const updatedCriteria = { ...criteria, toDate };
        // Auto-generate name if it's empty or default
        if (!updatedCriteria.name || updatedCriteria.name === "" || updatedCriteria.name === "New Reward Criteria" || updatedCriteria.name.includes("Rule applies") || updatedCriteria.name.includes("When ")) {
          updatedCriteria.name = generateRewardCriteriaName(updatedCriteria);
        }
        return updatedCriteria;
      }
      return criteria;
    })
  );
  setIsDirty(true);
};

  // Reward Criteria Functions - Updated for array structure
  const addRewardCriteriaCondition = (criteriaId) => {
    setRewardCriteria(prev => 
      prev.map(criteria => 
        criteria.id === criteriaId 
          ? { 
              ...criteria, 
              conditions: [...criteria.conditions, { 
                id: uuidv4(), 
                field: "", 
                operator: "==", 
                value: "" 
              }] 
            }
          : criteria
      )
    );
  };

const updateRewardCriteriaCondition = (criteriaId, condId, key, value) => {
  setRewardCriteria(prev => 
    prev.map(criteria => {
      if (criteria.id === criteriaId) {
        const updatedCriteria = {
          ...criteria,
          conditions: criteria.conditions.map(cond => 
            cond.id === condId ? { ...cond, [key]: value } : cond
          )
        };
        // Auto-generate name if it's empty or default
        if (!updatedCriteria.name || updatedCriteria.name === "" || updatedCriteria.name === "New Reward Criteria" || updatedCriteria.name.includes("Rule applies") || updatedCriteria.name.includes("When ")) {
          updatedCriteria.name = generateRewardCriteriaName(updatedCriteria);
        }
        return updatedCriteria;
      }
      return criteria;
    })
  );
  setIsDirty(true);
};

  const removeRewardCriteriaCondition = (criteriaId, condId) => {
    setRewardCriteria(prev => 
      prev.map(criteria => 
        criteria.id === criteriaId 
          ? {
              ...criteria,
              conditions: criteria.conditions.filter(cond => cond.id !== condId)
            }
          : criteria
      )
    );
  };

  const addRewardCriteria = () => {
    setRewardCriteria(prev => [...prev, { 
      id: uuidv4(), 
      name: "", 
      fromDate: "",
      toDate: "",
      conditions: [] 
    }]);
  };

  const updateRewardCriteriaName = (criteriaId, name) => {
    setRewardCriteria(prev => 
      prev.map(criteria => 
        criteria.id === criteriaId ? { ...criteria, name } : criteria
      )
    );
  };

  const removeRewardCriteria = (criteriaId) => {
    setRewardCriteria(prev => prev.filter(criteria => criteria.id !== criteriaId));
  };

  // Reward Rules Functions
const updateRewardRule = (ruleId, key, value) => {
  setRewardRules(prev => 
    prev.map(rule => {
      if (rule.id === ruleId) {
        const updatedRule = { ...rule, [key]: value };
        // Auto-generate name if it's empty or default
        if (!updatedRule.name || updatedRule.name === "" || updatedRule.name === "New Reward Rule" || updatedRule.name.includes("Give ")) {
          updatedRule.name = generateRewardRuleName(updatedRule);
        }
        return updatedRule;
      }
      return rule;
    })
  );
  setIsDirty(true);
};

  const addRewardRule = () => {
    setRewardRules(prev => [...prev, { 
      id: uuidv4(), 
      name: "", 
      rewardType: "fixed", 
      rewardValue: 0, 
      applyTarget: "order",
      destination: "wallet",
      limit: 0,
      applicableItems: []
    }]);
  };

  const removeRewardRule = (ruleId) => {
    setRewardRules(prev => prev.filter(rule => rule.id !== ruleId));
  };

  // Applicability Rules Functions
  const addApplicabilityCondition = (ruleId) => {
    setApplicabilityRules(prev => 
      prev.map(rule => 
        rule.id === ruleId 
          ? {
              ...rule,
              conditions: [...rule.conditions, { 
                id: uuidv4(), 
                field: "", 
                operator: "==", 
                value: "" 
              }]
            }
          : rule
      )
    );
  };

const updateApplicabilityCondition = (ruleId, condId, key, value) => {
  setApplicabilityRules(prev => 
    prev.map(rule => {
      if (rule.id === ruleId) {
        const updatedRule = {
          ...rule,
          conditions: rule.conditions.map(cond => 
            cond.id === condId ? { ...cond, [key]: value } : cond
          )
        };
        // Auto-generate name if it's empty or default
        if (!updatedRule.name || updatedRule.name === "" || updatedRule.name === "New Applicability Rule" || updatedRule.name.includes("Coins can be applied")) {
          updatedRule.name = generateApplicabilityRuleName(updatedRule);
        }
        return updatedRule;
      }
      return rule;
    })
  );
  setIsDirty(true);
};

  const removeApplicabilityCondition = (ruleId, condId) => {
    setApplicabilityRules(prev => 
      prev.map(rule => 
        rule.id === ruleId 
          ? {
              ...rule,
              conditions: rule.conditions.filter(cond => cond.id !== condId)
            }
          : rule
      )
    );
  };

  const addApplicabilityRule = () => {
    setApplicabilityRules(prev => [...prev, { 
      id: uuidv4(), 
      name: "", 
      conditions: [] 
    }]);
  };

const updateApplicabilityRuleName = (ruleId, name) => {
  setApplicabilityRules(prev => 
    prev.map(rule => 
      rule.id === ruleId ? { ...rule, name } : rule
    )
  );
  setIsDirty(true);
};

  const removeApplicabilityRule = (ruleId) => {
    setApplicabilityRules(prev => prev.filter(rule => rule.id !== ruleId));
  };

  // Updated Redemption Rules Functions
const updateRedemptionRule = (ruleId, key, value) => {
  setRedemptionRules(prev => 
    prev.map(rule => {
      if (rule.id === ruleId) {
        const updatedRule = { ...rule, [key]: value };
        // Auto-generate name if it's empty or default
        if (!updatedRule.name || updatedRule.name === "" || updatedRule.name === "New Redemption Rule" || updatedRule.name.includes("Redeem")) {
          updatedRule.name = generateRedemptionRuleName(updatedRule);
        }
        return updatedRule;
      }
      return rule;
    })
  );
  setIsDirty(true);
};


  const addRedemptionRule = () => {
    setRedemptionRules(prev => [...prev, { 
      id: uuidv4(), 
      name: "", 
      redeemType: "percentage",
      redeemValue: 0,
      applyTarget: "order"
    }]);
  };

  const removeRedemptionRule = (ruleId) => {
    setRedemptionRules(prev => prev.filter(rule => rule.id !== ruleId));
  };

  // Updated Expiry Rules Functions
const updateExpiryRule = (ruleId, key, value) => {
  setExpiryRules(prev => 
    prev.map(rule => {
      if (rule.id === ruleId) {
        const updatedRule = { ...rule, [key]: value };
        // Auto-generate name if it's empty or default
        if (!updatedRule.name || updatedRule.name === "" || updatedRule.name === "New Expiry Rule" || updatedRule.name.includes("Coins expire")) {
          updatedRule.name = generateExpiryRuleName(updatedRule);
        }
        return updatedRule;
      }
      return rule;
    })
  );
  setIsDirty(true);
};

  const addExpiryCondition = (ruleId) => {
    setExpiryRules(prev => 
      prev.map(rule => 
        rule.id === ruleId 
          ? {
              ...rule,
              conditions: [...rule.conditions, { 
                id: uuidv4(), 
                field: "", 
                operator: "==", 
                value: "" 
              }]
            }
          : rule
      )
    );
  };

const updateExpiryCondition = (ruleId, condId, key, value) => {
  setExpiryRules(prev => 
    prev.map(rule => {
      if (rule.id === ruleId) {
        const updatedRule = {
          ...rule,
          conditions: rule.conditions.map(cond => 
            cond.id === condId ? { ...cond, [key]: value } : cond
          )
        };
        // Auto-generate name if it's empty or default
        if (!updatedRule.name || updatedRule.name === "" || updatedRule.name === "New Expiry Rule" || updatedRule.name.includes("Coins expire")) {
          updatedRule.name = generateExpiryRuleName(updatedRule);
        }
        return updatedRule;
      }
      return rule;
    })
  );
  setIsDirty(true);
};

  const removeExpiryCondition = (ruleId, condId) => {
    setExpiryRules(prev => 
      prev.map(rule => 
        rule.id === ruleId 
          ? {
              ...rule,
              conditions: rule.conditions.filter(cond => cond.id !== condId)
            }
          : rule
      )
    );
  };

  const addExpiryRule = () => {
    setExpiryRules(prev => [...prev, { 
      id: uuidv4(), 
      name: "", 
      expiryType: "days",
      expiryValue: 60, 
      conditions: [] 
    }]);
  };

  const removeExpiryRule = (ruleId) => {
    setExpiryRules(prev => prev.filter(rule => rule.id !== ruleId));
  };

// Helper function to map dates from backend to frontend format
const mapDateFromBackend = (dateValue) => {
  if (!dateValue) return "";
  
  console.log('Mapping date from backend:', dateValue, typeof dateValue);
  
  try {
    // Handle different possible date formats from backend
    let dateObj;
    
    if (typeof dateValue === 'string') {
      // Check if it's already in DD/MM/YYYY format
      if (dateValue.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
        console.log('Date already in DD/MM/YYYY format:', dateValue);
        return dateValue; // Already in correct format
      }
      
      // Check if it's in YYYY-MM-DD format
      if (dateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month, day] = dateValue.split('-');
        const formatted = `${day}/${month}/${year}`;
        console.log('Converted YYYY-MM-DD to DD/MM/YYYY:', dateValue, '->', formatted);
        return formatted;
      }
      
      // Check if it's an ISO date string (like "2025-06-17T00:00:00.000Z")
      if (dateValue.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)) {
        dateObj = new Date(dateValue);
        if (!isNaN(dateObj.getTime())) {
          const day = String(dateObj.getDate()).padStart(2, '0');
          const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          const year = dateObj.getFullYear();
          const formatted = `${day}/${month}/${year}`;
          console.log('Converted ISO date to DD/MM/YYYY:', dateValue, '->', formatted);
          return formatted;
        }
      }
      
      // Check if it's in MM/DD/YYYY format
      if (dateValue.match(/^\d{2}\/\d{2}\/\d{4}$/) && dateValue.includes('/')) {
        // Try to determine if it's MM/DD/YYYY or DD/MM/YYYY
        // For now, assume it's MM/DD/YYYY and convert to DD/MM/YYYY
        const [month, day, year] = dateValue.split('/');
        const formatted = `${day}/${month}/${year}`;
        console.log('Converted MM/DD/YYYY to DD/MM/YYYY:', dateValue, '->', formatted);
        return formatted;
      }
      
      // Try to parse as general date string
      dateObj = new Date(dateValue);
    } else if (dateValue instanceof Date) {
      dateObj = dateValue;
    } else if (typeof dateValue === 'number') {
      // Handle timestamp
      dateObj = new Date(dateValue);
    } else {
      console.log('Unknown date format:', dateValue);
      return "";
    }
    
    // Convert Date object to DD/MM/YYYY format
    if (dateObj && !isNaN(dateObj.getTime())) {
      const day = String(dateObj.getDate()).padStart(2, '0');
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const year = dateObj.getFullYear();
      const formatted = `${day}/${month}/${year}`;
      console.log('Converted Date object to DD/MM/YYYY:', dateObj, '->', formatted);
      return formatted;
    }
    
    console.log('Could not parse date:', dateValue);
    return "";
  } catch (error) {
    console.error('Error parsing date:', dateValue, error);
    return "";
  }
};



  // Helper function to convert dates from frontend format to backend format
  const convertDateToBackendFormat = (dateValue) => {
    if (!dateValue) return "";
    
    try {
      // If it's in DD/MM/YYYY format, convert to YYYY-MM-DD
      if (dateValue.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
        const [day, month, year] = dateValue.split('/');
        return `${year}-${month}-${day}`;
      }
      
      // If it's already in YYYY-MM-DD format, return as is
      if (dateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return dateValue;
      }
      
      // Try to parse and convert
      const dateObj = new Date(dateValue);
      if (!isNaN(dateObj.getTime())) {
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      
      return "";
    } catch (error) {
      console.error('Error converting date to backend format:', dateValue, error);
      return "";
    }
  };

// Helper function to map condition values from backend to frontend
const mapConditionValueFromBackend = (field, value) => {
  if (value === null || value === undefined) return "";
  
  console.log(`Mapping condition value - Field: ${field}, Value:`, value, typeof value);
  
  switch(field) {
    case "location":
      if (Array.isArray(value)) {
        // Extract IDs from location objects
        return value.map(loc => {
          if (typeof loc === 'object' && loc.id) {
            return loc.id;
          } else if (typeof loc === 'string') {
            // Find location by name and return ID
            const location = locations.find(l => l.name === loc);
            return location ? location.id : loc;
          }
          return loc;
        });
      } else if (typeof value === 'object' && value.id) {
        return value.id;
      } else if (typeof value === 'string') {
        // Find location by name and return ID
        const location = locations.find(loc => loc.name === value);
        return location ? location.id : value;
      }
      return value;
    
    case "items":
      if (Array.isArray(value)) {
        return value.map(item => {
          if (typeof item === 'object' && item.id) {
            return item.id;
          } else if (typeof item === 'string') {
            // Find item by name and return ID
            const foundItem = items.find(i => i.name === item);
            return foundItem ? foundItem.id : item;
          }
          return item;
        });
      } else if (typeof value === 'object' && value.id) {
        return value.id;
      } else if (typeof value === 'string') {
        // Find item by name and return ID
        const item = items.find(item => item.name === value);
        return item ? item.id : value;
      }
      return value;
    
    case "category":
      if (typeof value === 'object' && value.name) {
        return value.name; // Return name for display
      } else if (typeof value === 'object' && value.id) {
        // Find category by ID and return name
        const category = categories.find(cat => cat.id === value.id);
        return category ? category.name : value.id;
      } else if (typeof value === 'string') {
        return value;
      }
      return value;
    
    case "brand":
      if (typeof value === 'object' && value.name) {
        return value.name; // Return name for display
      } else if (typeof value === 'object' && value.id) {
        // Find brand by ID and return name
        const brand = brands.find(b => b.id === value.id);
        return brand ? brand.name : value.id;
      } else if (typeof value === 'string') {
        return value;
      }
      return value;
    
    case "is_ecommerce":
      if (typeof value === 'boolean') {
        return value ? "Yes" : "No";
      } else if (typeof value === 'string') {
        return value.toLowerCase() === 'true' ? "Yes" : "No";
      }
      return value;
    
    case "amount":
      return typeof value === 'number' ? value.toString() : (value || "");
    
    case "campaign":
    case "event":
      return value ? value.toString() : "";
    
    default:
      // For any other field types, return as string
      if (typeof value === 'object') {
        return JSON.stringify(value);
      }
      return value ? value.toString() : "";
  }
};



  // Helper function to map applicable items from backend
  const mapApplicableItemsFromBackend = (applicableItems) => {
    if (!Array.isArray(applicableItems)) return [];
    
    return applicableItems.map(item => {
      if (typeof item === 'object' && item.id && item.name) {
        return { id: item.id, name: item.name };
      } else if (typeof item === 'string') {
        // Try to find the item in the items array
        const foundItem = items.find(i => i.id === item || i.name === item);
        return foundItem ? { id: foundItem.id, name: foundItem.name } : { id: item, name: item };
      }
      return item;
    });
  };



/* useEffect(() => {
  console.log("useEffect triggered with ruleData:", ruleData);
  
  if (ruleData && Object.keys(ruleData).length > 0) {
    console.log("Processing ruleData...");
    
    // Initialize rewardCriteria - Fix the nested structure access
    if (ruleData.rewardCriteria && ruleData.rewardCriteria.rewardCriteria && ruleData.rewardCriteria.rewardCriteria.length > 0) {
      console.log("Setting reward criteria:", ruleData.rewardCriteria.rewardCriteria);
      
      // Debug date mapping
      ruleData.rewardCriteria.rewardCriteria.forEach((criteria, index) => {
        console.log(`Criteria ${index} - Original fromDate:`, criteria.fromDate);
        console.log(`Criteria ${index} - Original toDate:`, criteria.toDate);
        console.log(`Criteria ${index} - Mapped fromDate:`, mapDateFromBackend(criteria.fromDate));
        console.log(`Criteria ${index} - Mapped toDate:`, mapDateFromBackend(criteria.toDate));
        console.log(`Criteria ${index} - Original conditions:`, criteria.conditions);
      });
      
      // Map all criteria from the nested array
      const mappedCriteria = ruleData.rewardCriteria.rewardCriteria.map(criteriaData => ({
        id: uuidv4(),
        name: criteriaData.name || "",
        fromDate: mapDateFromBackend(criteriaData.fromDate), // Convert date format
        toDate: mapDateFromBackend(criteriaData.toDate), // Convert date format
        conditions: (criteriaData.conditions || []).map(cond => ({
          id: uuidv4(),
          field: cond.field || "",
          operator: cond.operator || "==",
          value: mapConditionValueFromBackend(cond.field, cond.value) // Use helper function
        }))
      }));
      
      console.log("New reward criteria array with dates:", mappedCriteria);
      setRewardCriteria(mappedCriteria);
    }

    // Initialize rewardRules with applicableItems mapping
    if (ruleData.rewardRules && ruleData.rewardRules.length > 0) {
      console.log("Setting reward rules:", ruleData.rewardRules);
      
      setRewardRules(ruleData.rewardRules.map(rule => ({
        id: uuidv4(),
        name: rule.name || "",
        rewardType: rule.reward?.type || "fixed",
        rewardValue: rule.reward?.value || 0,
        applyTarget: rule.reward?.apply?.[0] || "order",
        destination: rule.reward?.destination?.[0] || "wallet",
        limit: rule.reward?.limit || 0,
        applicableItems: mapApplicableItemsFromBackend(rule.reward?.applicableItems || [])
      })));
    }

    // Initialize applicabilityRules with proper condition mapping
    if (ruleData.applicabilityRules && ruleData.applicabilityRules.length > 0) {
      console.log("Setting applicability rules:", ruleData.applicabilityRules);
      
      setApplicabilityRules(ruleData.applicabilityRules.map(rule => ({
        id: uuidv4(),
        name: rule.name || "",
        conditions: (rule.conditions || []).map(cond => ({
          id: uuidv4(),
          field: cond.field || "",
          operator: cond.operator || "==",
          value: mapConditionValueFromBackend(cond.field, cond.value)
        }))
      })));
    }

    // Initialize redemptionRules - Updated for new schema structure
    if (ruleData.redemptionRules && ruleData.redemptionRules.length > 0) {
      console.log("Setting redemption rules:", ruleData.redemptionRules);
      
      setRedemptionRules(ruleData.redemptionRules.map(rule => {
        let redeemType = "percentage";
        let redeemValue = 0;
        
        if (rule.redeem) {
          redeemType = rule.redeem.type || "percentage";
          redeemValue = rule.redeem.value || 0;
        }
        
        return {
          id: uuidv4(),
          name: rule.name || "",
          redeemType: redeemType,
          redeemValue: redeemValue,
          applyTarget: rule.redeem?.apply?.[0] || "order"
        };
      }));
    }

    // Initialize expiryRules with proper condition mapping
    if (ruleData.expiryRules && ruleData.expiryRules.length > 0) {
      console.log("Setting expiry rules:", ruleData.expiryRules);
      
      setExpiryRules(ruleData.expiryRules.map(rule => {
        let expiryType = rule.expiry?.type || "days";
        let expiryValue = rule.expiry?.value || 60;
        
        return {
          id: uuidv4(),
          name: rule.name || "",
          expiryType: expiryType,
          expiryValue: expiryValue,
          conditions: (rule.conditions || []).map(cond => ({
            id: uuidv4(),
            field: cond.field || "",
            operator: cond.operator || "==",
            value: mapConditionValueFromBackend(cond.field, cond.value)
          }))
        };
      }));
    }
  }
}, [ruleData, categories, brands, locations, items]); */ // Add dependencies


useEffect(() => {
  console.log("useEffect triggered with ruleData:", ruleData);
  
  // Only process if we have ruleData and it has an _id (to ensure it's valid data)
  if (ruleData && ruleData._id && Object.keys(ruleData).length > 0) {
    console.log("Processing ruleData...");
    
    // Initialize rewardCriteria - Fix the nested structure access
    if (ruleData.rewardCriteria && ruleData.rewardCriteria.rewardCriteria && ruleData.rewardCriteria.rewardCriteria.length > 0) {
      console.log("Setting reward criteria:", ruleData.rewardCriteria.rewardCriteria);
      
      // Debug date mapping
      ruleData.rewardCriteria.rewardCriteria.forEach((criteria, index) => {
        console.log(`Criteria ${index} - Original fromDate:`, criteria.fromDate);
        console.log(`Criteria ${index} - Original toDate:`, criteria.toDate);
        console.log(`Criteria ${index} - Mapped fromDate:`, mapDateFromBackend(criteria.fromDate));
        console.log(`Criteria ${index} - Mapped toDate:`, mapDateFromBackend(criteria.toDate));
        console.log(`Criteria ${index} - Original conditions:`, criteria.conditions);
      });
      
      // Map all criteria from the nested array
      const mappedCriteria = ruleData.rewardCriteria.rewardCriteria.map(criteriaData => ({
        id: uuidv4(),
        name: criteriaData.name || "",
        fromDate: mapDateFromBackend(criteriaData.fromDate), // Convert date format
        toDate: mapDateFromBackend(criteriaData.toDate), // Convert date format
        conditions: (criteriaData.conditions || []).map(cond => ({
          id: uuidv4(),
          field: cond.field || "",
          operator: cond.operator || "==",
          value: mapConditionValueFromBackend(cond.field, cond.value) // Use helper function
        }))
      }));
      
      console.log("New reward criteria array with dates:", mappedCriteria);
      setRewardCriteria(mappedCriteria);
    }

    // Initialize rewardRules with applicableItems mapping
    if (ruleData.rewardRules && ruleData.rewardRules.length > 0) {
      console.log("Setting reward rules:", ruleData.rewardRules);
      
      setRewardRules(ruleData.rewardRules.map(rule => ({
        id: uuidv4(),
        name: rule.name || "",
        rewardType: rule.reward?.type || "fixed",
        rewardValue: rule.reward?.value || 0,
        applyTarget: rule.reward?.apply?.[0] || "order",
        destination: rule.reward?.destination?.[0] || "wallet",
        limit: rule.reward?.limit || 0,
        applicableItems: mapApplicableItemsFromBackend(rule.reward?.applicableItems || [])
      })));
    }

    // Initialize applicabilityRules with proper condition mapping
    if (ruleData.applicabilityRules && ruleData.applicabilityRules.length > 0) {
      console.log("Setting applicability rules:", ruleData.applicabilityRules);
      
      setApplicabilityRules(ruleData.applicabilityRules.map(rule => ({
        id: uuidv4(),
        name: rule.name || "",
        conditions: (rule.conditions || []).map(cond => ({
          id: uuidv4(),
          field: cond.field || "",
          operator: cond.operator || "==",
          value: mapConditionValueFromBackend(cond.field, cond.value)
        }))
      })));
    }

    // Initialize redemptionRules - Updated for new schema structure
    if (ruleData.redemptionRules && ruleData.redemptionRules.length > 0) {
      console.log("Setting redemption rules:", ruleData.redemptionRules);
      
      setRedemptionRules(ruleData.redemptionRules.map(rule => {
        let redeemType = "percentage";
        let redeemValue = 0;
        
        if (rule.redeem) {
          redeemType = rule.redeem.type || "percentage";
          redeemValue = rule.redeem.value || 0;
        }
        
        return {
          id: uuidv4(),
          name: rule.name || "",
          redeemType: redeemType,
          redeemValue: redeemValue,
          applyTarget: rule.redeem?.apply?.[0] || "order"
        };
      }));
    }

    // Initialize expiryRules with proper condition mapping
    if (ruleData.expiryRules && ruleData.expiryRules.length > 0) {
      console.log("Setting expiry rules:", ruleData.expiryRules);
      
      setExpiryRules(ruleData.expiryRules.map(rule => {
        let expiryType = rule.expiry?.type || "days";
        let expiryValue = rule.expiry?.value || 60;
        
        return {
          id: uuidv4(),
          name: rule.name || "",
          expiryType: expiryType,
          expiryValue: expiryValue,
          conditions: (rule.conditions || []).map(cond => ({
            id: uuidv4(),
            field: cond.field || "",
            operator: cond.operator || "==",
            value: mapConditionValueFromBackend(cond.field, cond.value)
          }))
        };
      }));
    }
  }
}, [ruleData?._id]); // Only depend on the rule ID to prevent infinite loops

  // Updated buildRule function to match new schema
const buildRule = () => {
  return {
    rewardCriteria: rewardCriteria.map(criteria => ({
      name: criteria.name,
      fromDate: convertDateToBackendFormat(criteria.fromDate), // Convert to backend format
      toDate: convertDateToBackendFormat(criteria.toDate), // Convert to backend format
      conditions: criteria.conditions.map(({ field, operator, value }) => ({
        field,
        operator,
        value: (() => {
          switch(field) {
            case "amount":
              return parseFloat(value) || 0;
            
            case "is_ecommerce":
              return value === "Yes" || value === "true" || value === true;
            
            case "location":
              if (Array.isArray(value)) {
                // Filter out "all" and ensure we only have individual location IDs
                const selectedLocationIds = value.filter(id => id !== "all");
                return selectedLocationIds.map(locId => {
                  const location = locations.find(loc => loc.id === locId);
                  return location ? { id: location.id, name: location.name } : { id: locId, name: 'Unknown Location' };
                });
              } else {
                const location = locations.find(loc => loc.name === value || loc.id === value);
                return location ? { id: location.id, name: location.name } : { id: value, name: value };
              }
            
            case "items":
              const item = items.find(item => item.name === value || item.id === value);
              return item ? { id: item.id, name: item.name } : { id: value, name: value };
            
            case "category":
              const category = categories.find(cat => cat.name === value || cat.id === value);
              return category ? { id: category.id, name: category.name } : { id: value, name: value };
            
            case "brand":
              const brand = brands.find(brand => brand.name === value || brand.id === value);
              return brand ? { id: brand.id, name: brand.name } : { id: value, name: value };
            
            case "campaign":
            case "event":
              return value || "";
            
            default:
              return value;
          }
        })(),
      })),
    })),
    rewardRules: rewardRules.map(rule => ({
      name: rule.name,
      reward: {
        type: rule.rewardType,
        value: rule.rewardType === "fixed" ? parseInt(rule.rewardValue) : parseFloat(rule.rewardValue),
        apply: [rule.applyTarget],
        destination: [rule.destination],
        applicableItems: rule.applicableItems && Array.isArray(rule.applicableItems) 
          ? (() => {
              // Filter out "all" and ensure we only have individual item IDs
              const selectedItemIds = rule.applicableItems.map(item => 
                typeof item === 'object' ? item.id : item
              ).filter(id => id !== "all");
              
              return selectedItemIds.map(itemId => {
                const item = rule.applicableItems.find(ruleItem => 
                  (typeof ruleItem === 'object' ? ruleItem.id : ruleItem) === itemId
                );
                
                if (typeof item === 'object' && item.id && item.name) {
                  return { id: item.id, name: item.name };
                } else {
                  const fullItem = items.find(i => i.id === itemId);
                  return fullItem ? { id: fullItem.id, name: fullItem.name } : { id: itemId, name: 'Unknown Item' };
                }
              });
            })()
          : [],
        limit: rule.rewardType === "fixed" ? parseInt(rule.limit) : parseFloat(rule.limit),
      },
    })),
    applicabilityRules: applicabilityRules.map(rule => ({
      name: rule.name,
      conditions: rule.conditions.map(({ field, operator, value }) => ({
        field,
        operator,
        value: (() => {
          switch(field) {
            case "amount":
              return parseFloat(value) || 0;
            
            case "is_ecommerce":
              return value === "Yes" || value === "true" || value === true;
            
            case "location":
              if (Array.isArray(value)) {
                // Filter out "all" and ensure we only have individual location IDs
                const selectedLocationIds = value.filter(id => id !== "all");
                return selectedLocationIds.map(locId => {
                  const location = locations.find(loc => loc.id === locId);
                  return location ? { id: location.id, name: location.name } : { id: locId, name: 'Unknown Location' };
                });
              } else {
                const location = locations.find(loc => loc.name === value || loc.id === value);
                return location ? { id: location.id, name: location.name } : { id: value, name: value };
              }
            
            case "category":
              const category = categories.find(cat => cat.name === value || cat.id === value);
              return category ? { id: category.id, name: category.name } : { id: value, name: value };
            
            case "brand":
              const brand = brands.find(brand => brand.name === value || brand.id === value);
              return brand ? { id: brand.id, name: brand.name } : { id: value, name: value };
            
            case "items":
              const item = items.find(item => item.name === value || item.id === value);
              return item ? { id: item.id, name: item.name } : { id: value, name: value };
            
            case "campaign":
            case "event":
              return value || "";
            
            default:
              return value;
          }
        })(),
      })),
    })),
    redemptionRules: redemptionRules.map(rule => ({
      name: rule.name,
      redeem: {
        type: rule.redeemType,
        value: parseFloat(rule.redeemValue),
        apply: [rule.applyTarget]
      }
    })),
    expiryRules: expiryRules.map(rule => ({
      name: rule.name,
      expiry: {
        type: rule.expiryType,
        value: parseInt(rule.expiryValue)
      },
      conditions: rule.conditions.map(({ field, operator, value }) => ({
        field,
        operator,
        value: (() => {
          switch(field) {
            case "amount":
              return parseFloat(value) || 0;
            
            case "is_ecommerce":
              return value === "Yes" || value === "true" || value === true;
            
            case "location":
              if (Array.isArray(value)) {
                // Filter out "all" and ensure we only have individual location IDs
                const selectedLocationIds = value.filter(id => id !== "all");
                return selectedLocationIds.map(locId => {
                  const location = locations.find(loc => loc.id === locId);
                  return location ? { id: location.id, name: location.name } : { id: locId, name: 'Unknown Location' };
                });
              } else {
                const location = locations.find(loc => loc.name === value || loc.id === value);
                return location ? { id: location.id, name: location.name } : { id: value, name: value };
              }
            
            case "category":
              const category = categories.find(cat => cat.name === value || cat.id === value);
              return category ? { id: category.id, name: category.name } : { id: value, name: value };
            
            case "brand":
              const brand = brands.find(brand => brand.name === value || brand.id === value);
              return brand ? { id: brand.id, name: brand.name } : { id: value, name: value };
            
            case "items":
              const item = items.find(item => item.name === value || item.id === value);
              return item ? { id: item.id, name: item.name } : { id: value, name: value };
            
            case "campaign":
            case "event":
              return value || "";
            
            default:
              return value;
          }
        })(),
      })),
    })),
  };
};

// Update the saveRulesToSession function
const saveRulesToSession = () => {
  try {
    const rulesData = buildRule();
    sessionStorage.setItem('savedRules', JSON.stringify(rulesData));
    alert('Rules saved successfully to session!');
    console.log('Complete rules JSON saved to session:', rulesData);
  } catch (error) {
    console.error('Error saving rules:', error);
    alert('Error saving rules. Please try again.');
  }
};

// Add this function to load rules from session (optional - for future use)
const loadRulesFromSession = () => {
  try {
    const savedData = sessionStorage.getItem('savedRules');
    if (savedData) {
      const parsedData = JSON.parse(savedData);
      console.log('Loaded rules from session:', parsedData);
      return parsedData;
    }
    return null;
  } catch (error) {
    console.error('Error loading rules from session:', error);
    return null;
  }
};

useEffect(() => {
  fetchCategories();
  fetchBrands();
  fetchLocations();
}, []);

// Fetch Categories
const fetchCategories = async () => {
            const token = sessionStorage.getItem('token');
  try {
    setLoading(true);
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product-category/get-all-productCategories`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log(data)
    // Ensure data has id and name properties
    const formattedCategories = (data.data).map(cat => ({
      id:cat._id,
      name:cat.product_category_name
    }));
    setCategories(formattedCategories); 
  } catch (error) {
    console.error('Error fetching categories:', error);
    setCategories([]);
  } finally {
    setLoading(false);
  }
};

// Fetch Brands
const fetchBrands = async () => {
            const token = sessionStorage.getItem('token');
  try {
    setLoading(true);
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}vendor/get-all-vendors`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
         'x-token': token
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log(data)
    const formattedBrands = (data.data).map(brand => ({
      id:brand._id,
      name:brand.name
    }));
    setBrands(formattedBrands); 
  } catch (error) {
    console.error('Error fetching brands:', error);
    setBrands([]);
  } finally {
    setLoading(false);
  }
};

  //Fetch Items
const fetchItems = async (categoryId, brandId) => {
  if (!categoryId || !brandId) {
    setItems([]);
    return;
  }

  const token = sessionStorage.getItem('token');
  try {
    setLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}product/get-products-by-category-and-vendor?product_category_id=${categoryId}&vendor_id=${brandId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Items data:', data);
    
    const formattedItems = (data.data || []).map(item => ({
      id: item._id,
      name: item.product_name || item.name
    }));
    
    setItems(formattedItems);
  } catch (error) {
    console.error('Error fetching items:', error);
    setItems([]);
  } finally {
    setLoading(false);
  }
};

  //Fetch Locations
const fetchLocations = async () => {
  const token = sessionStorage.getItem('token');
  try {
    setLoading(true);
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}organization/get-all-organizations`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Locations data:', data);
    
    // Format locations with "All" option first, then actual locations
    const formattedLocations = [
      { id: "all", name: "All" }, // Keep the "All" option
      ...(data.data || []).map(location => ({
        id: location._id,
        name: location.city || location.name || location.organization_name // Use city field or fallback
      }))
    ];
    
    setLocations(formattedLocations);
  } catch (error) {
    console.error('Error fetching locations:', error);
    // Fallback to static locations if API fails
    setLocations([
      { id: "all", name: "All" },
      { id: "hyderabad", name: "Hyderabad" },
      { id: "vijayawada", name: "Vijayawada" },
      { id: "guntur", name: "Guntur" },
      { id: "visakhapatnam", name: "Visakhapatnam" }
    ]);
  } finally {
    setLoading(false);
  }
};

// Add this useEffect at the component level (outside of any functions)
/* useEffect(() => {
  // Check all reward criteria conditions for category and brand combinations
  rewardCriteria.forEach(criteria => {
    const categoryCondition = criteria.conditions.find(c => c.field === 'category');
    const brandCondition = criteria.conditions.find(c => c.field === 'brand');
    
    if (categoryCondition?.value && brandCondition?.value) {
      const categoryId = categories.find(cat => cat.name === categoryCondition.value)?.id;
      const brandId = brands.find(brand => brand.name === brandCondition.value)?.id;
      
      if (categoryId && brandId) {
        fetchItems(categoryId, brandId);
      }
    }
  });
}, [rewardCriteria, categories, brands]); */

// Separate useEffect for items fetching when categories/brands are available
useEffect(() => {
  // Only run this effect if we have categories and brands loaded
  if (categories.length > 0 && brands.length > 0) {
    // Check all reward criteria conditions for category and brand combinations
    rewardCriteria.forEach(criteria => {
      const categoryCondition = criteria.conditions.find(c => c.field === 'category');
      const brandCondition = criteria.conditions.find(c => c.field === 'brand');
      
      if (categoryCondition?.value && brandCondition?.value) {
        const categoryId = categories.find(cat => cat.name === categoryCondition.value)?.id;
        const brandId = brands.find(brand => brand.name === brandCondition.value)?.id;
        
        if (categoryId && brandId) {
          fetchItems(categoryId, brandId);
        }
      }
    });
  }
}, [categories.length, brands.length]); // Only depend on the length to avoid infinite loops


const renderConditions = (conditions, onUpdate, onRemove, parentId, onAdd) => (
  <div className="space-y-3">
    {conditions.map((cond) => {
      const selectedField = fields.find(f => f.value === cond.field);
      
      return (
        <div key={cond.id} className="flex gap-3 items-center p-3 bg-gray-50 rounded-lg">
          <select
            className="border border-gray-300 p-2 rounded-md flex-1"
            value={cond.field}
            onChange={(e) => onUpdate(parentId, cond.id, "field", e.target.value)}
          >
            <option value="">Select Field</option>
            {fields.map((f) => (
              <option key={f.value} value={f.value}>{f.label}</option>
            ))}
          </select>
          
          <select
            className="border border-gray-300 p-2 rounded-md flex-1"
            value={cond.operator}
            onChange={(e) => onUpdate(parentId, cond.id, "operator", e.target.value)}
          >
            {operators.map((op) => (
              <option key={op.value} value={op.value}>{op.label}</option>
            ))}
          </select>
          
          {/* Dynamic value input based on field type */}
          {selectedField?.type === "multiselect" ? (
            <MultiSelectDropdown
              options={selectedField.options}
              selectedValues={Array.isArray(cond.value) ? cond.value : (cond.value ? [cond.value] : [])}
              onChange={(selectedValues) => onUpdate(parentId, cond.id, "value", selectedValues)}
              placeholder={`Select ${selectedField.label}`}
            />
          ) : selectedField?.type === "select" ? (
            <select
              className="border border-gray-300 p-2 rounded-md flex-1"
              value={cond.value}
              onChange={(e) => onUpdate(parentId, cond.id, "value", e.target.value)}
            >
              <option value="">Select Value</option>
              {selectedField.options.map((option) => (
                <option key={option.id} value={option.name}>
                  {option.name}
                </option>
              ))}
            </select>
          ) : (
            <input
              className="border border-gray-300 p-2 rounded-md flex-1"
              type={selectedField?.value === "amount" ? "number" : "text"}
              value={cond.value}
              onChange={(e) => onUpdate(parentId, cond.id, "value", e.target.value)}
              placeholder="Value"
            />
          )}
          
          <button
            onClick={() => onRemove(parentId, cond.id)}
            className="px-2 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors"
            title="" data-tooltip="Delete Condition"  style={{ '--tooltip-bg': 'black' }}
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </div>
      );
    })}
    <button 
      onClick={() => onAdd(parentId)} 
      className="px-2 py-1 bg-[#f7525a] text-white rounded-md transition-colors"
      title="" data-tooltip="Add Condition"  style={{ '--tooltip-bg': 'black' }}
      disabled={loading}
    >
      {loading ? "Loading..." : "+Add Condition"}
    </button>
  </div>
);


  const handleChange = (e) => {
    const { name, value } = e.target;
    const previousValue = data[name];
    setData((prevState) => ({ ...prevState, [name]: value }));
    if (value !== previousValue) {
      setIsDirty(true);
    }

    let error = '';
    if (name === 'mobile_number') {
      if (value.length > 10 || !/^[0-9]*$/.test(value)) {
        return;
      }
      if (value.length < 10 && value.length > 0) {
        error = 'Enter 10 Digits Mobile Number please';
      }
    }
    if (name === 'email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value && !emailRegex.test(value)) {
        error = 'Please enter a valid email address';
      }
    }
    if (name === 'gst') {
      if (value.length > 15) {
        return;
      }
    }
    if (name === 'pan') {
      if (value.length > 10) {
        return;
      }
    }

    setErrors((prevState) => ({ ...prevState, [name]: error }));
  };

  // Add helper functions to generate dynamic rule names
const generateRewardCriteriaName = (criteria) => {
  if (!criteria.conditions || criteria.conditions.length === 0) {
    if (criteria.fromDate && criteria.toDate) {
      return `Rule applies between ${criteria.fromDate} and ${criteria.toDate}`;
    }
    return "New Reward Criteria";
  }
  
  const conditionStrings = criteria.conditions.map(cond => {
    if (!cond.field || !cond.operator || (!cond.value && cond.value !== false && cond.value !== 0)) return "";
    
    const fieldLabel = fields.find(f => f.value === cond.field)?.label || cond.field;
    const operatorLabel = operators.find(op => op.value === cond.operator)?.label || cond.operator;
    
    let valueString = "";
    if (cond.field === "location" && Array.isArray(cond.value)) {
      const locationNames = cond.value.map(locId => {
        const location = locations.find(loc => loc.id === locId);
        return location ? location.name : locId;
      });
      valueString = locationNames.length > 2 
        ? `${locationNames.slice(0, 2).join(", ")} and ${locationNames.length - 2} more` 
        : locationNames.join(", ");
    } else if (cond.field === "items" && Array.isArray(cond.value)) {
      const itemNames = cond.value.map(itemId => {
        const item = items.find(i => i.id === itemId);
        return item ? item.name : itemId;
      });
      valueString = itemNames.length > 2 
        ? `${itemNames.slice(0, 2).join(", ")} and ${itemNames.length - 2} more` 
        : itemNames.join(", ");
    } else if (cond.field === "amount") {
      valueString = `₹${cond.value}`;
    } else if (cond.field === "is_ecommerce") {
      valueString = cond.value === "Yes" ? "Yes" : "No";
    } else {
      valueString = cond.value.toString();
    }
    
    return `${fieldLabel} ${operatorLabel} ${valueString}`;
  }).filter(str => str !== "");
  
  if (conditionStrings.length === 0) {
    if (criteria.fromDate && criteria.toDate) {
      return `Rule applies between ${criteria.fromDate} and ${criteria.toDate}`;
    }
    return "New Reward Criteria";
  }
  
  let baseStatement;
  if (conditionStrings.length === 1) {
    baseStatement = `When ${conditionStrings[0]}`;
  } else if (conditionStrings.length === 2) {
    baseStatement = `When ${conditionStrings[0]} and ${conditionStrings[1]}`;
  } else {
    baseStatement = `When ${conditionStrings[0]}, ${conditionStrings[1]} and ${conditionStrings.length - 2} more conditions`;
  }
  
  // Add date range if both dates are present
  if (criteria.fromDate && criteria.toDate) {
    baseStatement += `, then this rule applies between ${criteria.fromDate} and ${criteria.toDate}`;
  } else if (criteria.fromDate) {
    baseStatement += `, then this rule applies from ${criteria.fromDate}`;
  } else if (criteria.toDate) {
    baseStatement += `, then this rule applies until ${criteria.toDate}`;
  } else {
    baseStatement += `, then this rule applies`;
  }
  
  return baseStatement;
};


const generateRewardRuleName = (rule) => {
  if (!rule.rewardType || (!rule.rewardValue && rule.rewardValue !== 0)) {
    return "New Reward Rule";
  }
  
  // Format reward amount
  let rewardAmount = "";
  if (rule.rewardType === "fixed") {
    rewardAmount = `${rule.rewardValue} coins`;
  } else if (rule.rewardType === "percentage") {
    rewardAmount = `${rule.rewardValue}% coins`;
  }
  
  // Format what it's applied on
  let appliedOn = "";
  if (rule.applyTarget === "order") {
    appliedOn = "order value";
  } else if (rule.applyTarget === "item") {
    if (rule.applicableItems && rule.applicableItems.length > 0) {
      if (rule.applicableItems.length === 1) {
        appliedOn = `${rule.applicableItems[0].name || 'selected item'}`;
      } else if (rule.applicableItems.length === 2) {
        appliedOn = `${rule.applicableItems[0].name || 'item'} and ${rule.applicableItems[1].name || 'item'}`;
      } else {
        appliedOn = `${rule.applicableItems[0].name || 'item'}, ${rule.applicableItems[1].name || 'item'} and ${rule.applicableItems.length - 2} more items`;
      }
    } else {
      appliedOn = "selected items";
    }
  }
  
  // Format destination
  let destination = "";
  if (rule.destination === "wallet") {
    destination = "wallet";
  } else if (rule.destination === "immediate") {
    destination = "immediate order discount";
  }
  
  // Format limit
  let limitText = "";
  if (rule.limit && rule.limit > 0) {
    if (rule.rewardType === "fixed") {
      limitText = ` (max ${rule.limit} coins per order)`;
    } else if (rule.rewardType === "percentage") {
      limitText = ` (max ${rule.limit}% of order value)`;
    }
  }
  
  // Construct the final name
  let ruleName = "";
  
  if (rule.applyTarget === "order") {
    ruleName = `Give ${rewardAmount} on ${appliedOn} to ${destination}${limitText}`;
  } else if (rule.applyTarget === "item") {
    if (rule.applicableItems && rule.applicableItems.length > 0) {
      ruleName = `Give ${rewardAmount} on ${appliedOn} to ${destination}${limitText}`;
    } else {
      ruleName = `Give ${rewardAmount} on selected items to ${destination}${limitText}`;
    }
  }
  
  return ruleName;
};


const generateApplicabilityRuleName = (rule) => {
  if (!rule.conditions || rule.conditions.length === 0) {
    return "New Applicability Rule";
  }
  
  const conditionStrings = rule.conditions.map(cond => {
    if (!cond.field || !cond.operator || (!cond.value && cond.value !== false && cond.value !== 0)) return "";
    
    const fieldLabel = fields.find(f => f.value === cond.field)?.label || cond.field;
    const operatorLabel = operators.find(op => op.value === cond.operator)?.label || cond.operator;
    
    let valueString = "";
    if (cond.field === "location" && Array.isArray(cond.value)) {
      const locationNames = cond.value.map(locId => {
        const location = locations.find(loc => loc.id === locId);
        return location ? location.name : locId;
      });
      valueString = locationNames.length > 2 
        ? `${locationNames.slice(0, 2).join(", ")} and ${locationNames.length - 2} more` 
        : locationNames.join(", ");
    } else if (cond.field === "items" && Array.isArray(cond.value)) {
      const itemNames = cond.value.map(itemId => {
        const item = items.find(i => i.id === itemId);
        return item ? item.name : itemId;
      });
      valueString = itemNames.length > 2 
        ? `${itemNames.slice(0, 2).join(", ")} and ${itemNames.length - 2} more` 
        : itemNames.join(", ");
    } else if (cond.field === "amount") {
      valueString = `₹${cond.value}`;
    } else if (cond.field === "is_ecommerce") {
      valueString = cond.value === "Yes" ? "Yes" : "No";
    } else if (cond.field === "category") {
      valueString = cond.value;
    } else if (cond.field === "brand") {
      valueString = cond.value;
    } else if (cond.field === "campaign") {
      valueString = cond.value;
    } else if (cond.field === "event") {
      valueString = cond.value;
    } else {
      valueString = cond.value.toString();
    }
    
    return `${fieldLabel} ${operatorLabel} ${valueString}`;
  }).filter(str => str !== "");
  
  if (conditionStrings.length === 0) {
    return "New Applicability Rule";
  }
  
  // Create the applicability statement
  let applicabilityStatement = "";
  if (conditionStrings.length === 1) {
    applicabilityStatement = `Coins can be applied when ${conditionStrings[0]}`;
  } else if (conditionStrings.length === 2) {
    applicabilityStatement = `Coins can be applied when ${conditionStrings[0]} and ${conditionStrings[1]}`;
  } else if (conditionStrings.length === 3) {
    applicabilityStatement = `Coins can be applied when ${conditionStrings[0]}, ${conditionStrings[1]} and ${conditionStrings[2]}`;
  } else {
    applicabilityStatement = `Coins can be applied when ${conditionStrings[0]}, ${conditionStrings[1]} and ${conditionStrings.length - 2} more conditions are met`;
  }
  
  return applicabilityStatement;
};


const generateRedemptionRuleName = (rule) => {
  if (!rule.redeemType || (!rule.redeemValue && rule.redeemValue !== 0)) {
    return "New Redemption Rule";
  }
  
  // Format redeem amount
  let redeemAmount = "";
  if (rule.redeemType === "fixed") {
    redeemAmount = `${rule.redeemValue} coins`;
  } else if (rule.redeemType === "percentage") {
    redeemAmount = `${rule.redeemValue}%`;
  }
  
  // Format what it's applied on
  let applyTarget = "";
  switch (rule.applyTarget) {
    case "order":
      applyTarget = "order value";
      break;
    case "item":
      applyTarget = "item value";
      break;
    case "coins":
    case "buildcoins":
      applyTarget = "available buildcoins";
      break;
    default:
      applyTarget = rule.applyTarget || "order value";
  }
  
  // Construct the final name based on redemption type
  let ruleName = "";
  
  if (rule.redeemType === "fixed") {
    if (rule.applyTarget === "coins" || rule.applyTarget === "buildcoins") {
      ruleName = `Redeem up to ${redeemAmount} from ${applyTarget}`;
    } else {
      ruleName = `Redeem ${redeemAmount} worth discount on ${applyTarget}`;
    }
  } else if (rule.redeemType === "percentage") {
    if (rule.applyTarget === "coins" || rule.applyTarget === "buildcoins") {
      ruleName = `Redeem ${redeemAmount} of ${applyTarget}`;
    } else {
      ruleName = `Redeem ${redeemAmount} discount on ${applyTarget}`;
    }
  }
  
  return ruleName;
};


const generateExpiryRuleName = (rule) => {
  if (!rule.expiryType || !rule.expiryValue) {
    return "New Expiry Rule";
  }
  
  // Format expiry period
  const expiryPeriod = `${rule.expiryValue} ${rule.expiryType}`;
  const hasConditions = rule.conditions && rule.conditions.length > 0;
  
  if (!hasConditions) {
    // Simple expiry without conditions
    return `Coins expire after ${expiryPeriod}`;
  }
  
  // Process conditions
  const conditionStrings = rule.conditions.map(cond => {
    if (!cond.field || !cond.operator || (!cond.value && cond.value !== false && cond.value !== 0)) return "";
    
    const fieldLabel = fields.find(f => f.value === cond.field)?.label || cond.field;
    const operatorLabel = operators.find(op => op.value === cond.operator)?.label || cond.operator;
    
    let valueString = "";
    if (cond.field === "location" && Array.isArray(cond.value)) {
      const locationNames = cond.value.map(locId => {
        const location = locations.find(loc => loc.id === locId);
        return location ? location.name : locId;
      });
      valueString = locationNames.length > 2 
        ? `${locationNames.slice(0, 2).join(", ")} and ${locationNames.length - 2} more` 
        : locationNames.join(", ");
    } else if (cond.field === "items" && Array.isArray(cond.value)) {
      const itemNames = cond.value.map(itemId => {
        const item = items.find(i => i.id === itemId);
        return item ? item.name : itemId;
      });
      valueString = itemNames.length > 2 
        ? `${itemNames.slice(0, 2).join(", ")} and ${itemNames.length - 2} more` 
        : itemNames.join(", ");
    } else if (cond.field === "amount") {
      valueString = `₹${cond.value}`;
    } else if (cond.field === "is_ecommerce") {
      valueString = cond.value === "Yes" ? "Yes" : "No";
    } else if (cond.field === "category") {
      valueString = cond.value;
    } else if (cond.field === "brand") {
      valueString = cond.value;
    } else if (cond.field === "campaign") {
      valueString = cond.value;
    } else if (cond.field === "event") {
      valueString = cond.value;
    } else {
      valueString = cond.value.toString();
    }
    
    return `${fieldLabel} ${operatorLabel} ${valueString}`;
  }).filter(str => str !== "");
  
  if (conditionStrings.length === 0) {
    return `Coins expire after ${expiryPeriod}`;
  }
  
  // Create expiry statement with conditions
  let expiryStatement = "";
  if (conditionStrings.length === 1) {
    expiryStatement = `Coins expire after ${expiryPeriod} when ${conditionStrings[0]}`;
  } else if (conditionStrings.length === 2) {
    expiryStatement = `Coins expire after ${expiryPeriod} when ${conditionStrings[0]} and ${conditionStrings[1]}`;
  } else if (conditionStrings.length === 3) {
    expiryStatement = `Coins expire after ${expiryPeriod} when ${conditionStrings[0]}, ${conditionStrings[1]} and ${conditionStrings[2]}`;
  } else {
    expiryStatement = `Coins expire after ${expiryPeriod} when ${conditionStrings[0]}, ${conditionStrings[1]} and ${conditionStrings.length - 2} more conditions are met`;
  }
  
  return expiryStatement;
};



  const handleSubmit = async (attempt = 1) => {
   try {
    setIsSaving(true);
    const rulesData = buildRule();
    
    console.log('Updating rules to backend...', rulesData);
    
    const response = await fetch(`${process.env.REACT_APP_FORE_BUILDCOINS}rules/update/${ruleData._id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(rulesData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    
    alert('Rules updated successfully!');
    console.log('Rules updated successfully:', result);
    
    // Reset dirty state
    setIsDirty(false);
    
    // Navigate to rules list
    navigate('/bb/app/rewardrules/rewardruleslist');
    
    return result;
  } catch (error) {
    console.error('Error updating rules:', error);
    alert(`Error updating rules: ${error.message}`);
    
    // Retry logic
    if (attempt < 3) {
      console.log(`Retrying update attempt ${attempt + 1}...`);
      return handleSubmit(attempt + 1);
    }
    
    throw error;
  } finally {
    setIsSaving(false);
  }
  };

  const handleCancel = () => {
    if (isDirty) {
      setShowCancelPopup(true);
    } else {
      navigate(-1);
    }
  };

  // Add these utility functions at the top of your component
const formatDateForDisplay = (dateString) => {
  if (!dateString) return '';
  // Convert YYYY-MM-DD to DD/MM/YYYY for display
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
};

const formatDateForInput = (displayDate) => {
  if (!displayDate) return '';
  
  try {
    // If it's in DD/MM/YYYY format, convert to YYYY-MM-DD for input value
    if (displayDate.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
      const [day, month, year] = displayDate.split('/');
      if (day && month && year && day.length === 2 && month.length === 2 && year.length === 4) {
        return `${year}-${month}-${day}`;
      }
    }
    
    // If it's already in YYYY-MM-DD format, return as is
    if (displayDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return displayDate;
    }
    
    return '';
  } catch (error) {
    console.error('Error formatting date for input:', displayDate, error);
    return '';
  }
};


const validateAndFormatDate = (input) => {
  // Remove any non-numeric characters except slashes
  let cleaned = input.replace(/[^\d/]/g, '');
  
  // Auto-format as user types (DD/MM/YYYY)
  if (cleaned.length >= 2 && cleaned.indexOf('/') === -1) {
    cleaned = cleaned.substring(0, 2) + '/' + cleaned.substring(2);
  }
  if (cleaned.length >= 5 && cleaned.lastIndexOf('/') === 2) {
    cleaned = cleaned.substring(0, 5) + '/' + cleaned.substring(5);
  }
  
  // Limit to 10 characters (DD/MM/YYYY)
  cleaned = cleaned.substring(0, 10);
  
  return cleaned;
};

// Enhanced date input handlers with DD/MM/YYYY format
const handleDateInput = (criteriaId, dateType, value, isCalendarInput = false) => {
  let formattedValue;
  
  if (isCalendarInput) {
    // Value from calendar is in YYYY-MM-DD format, convert to DD/MM/YYYY
    formattedValue = formatDateForDisplay(value);
  } else {
    // Value from typing, validate and format
    formattedValue = validateAndFormatDate(value);
  }
  
  if (dateType === 'from') {
    updateRewardCriteriaFromDate(criteriaId, formattedValue);
  } else {
    updateRewardCriteriaToDate(criteriaId, formattedValue);
  }
};


return (
    <div className="bg-white flex flex-col w-full h-full">
      <div className="flex flex-row w-full h-full">
        <div className="w-full flex-1 flex flex-col h-full">
        {loading && (
  <div className="absolute top-16 left-0 right-0 bg-blue-100 text-blue-800 px-4 py-2 text-center">
    Loading categories and brands...
  </div>
)}

              <div className="flex-1 overflow-y-auto">
                <div className="p-6 space-y-6">
                  {/*Reward Section start*/}
<div className="bg-white border border-gray-300 rounded-lg p-6 space-y-6">
                  {/* Reward Criteria Array */}
                  <div className="bg-white rounded-lg border border-gray-300 p-6">
                    <div className="flex justify-between items-center mb-6">
                      {/* <h2 className="text-lg font-semibold">Reward Criteria</h2> */}
                      <h2 className="text-lg font-semibold">When/Where do you want to give coins?(Criteria)</h2>
                      <button 
                        onClick={addRewardCriteria} 
                        className="px-2 py-1 bg-[#f7525a] text-white rounded-md hover:bg-[#e6474f] transition-colors"
                        title="" data-tooltip="Add Criteria"  style={{ '--tooltip-bg': 'black' }}
                      >
                        + 
                      </button>
                    </div>
                    {rewardCriteria.map((criteria, index) => (
                      <div key={criteria.id} className="mb-6 p-4 border border-gray-200 rounded-lg">
                        <div className="flex justify-between items-center mb-4">
                          <div className="flex-1 mr-4">
                            {/* <label className="block text-sm font-medium text-gray-700 mb-2">
                              Criteria Name
                            </label> */}
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Rule Name
                            </label>
                            <input
                              className="w-full border border-gray-300 p-1 rounded-md focus:ring-2 focus:ring-[#0f4392] focus:border-[#0f4392] outline-none"
                              value={criteria.name || generateRewardCriteriaName(criteria)}
                              onChange={(e) => updateRewardCriteriaName(criteria.id, e.target.value)}
                              /* placeholder="Enter criteria name" */
                              placeholder="Enter reward rule name or leave blank for auto-generation"
                            />
                          </div>
                          {rewardCriteria.length > 1 && (
                            <button 
                              onClick={() => removeRewardCriteria(criteria.id)} 
                              className="px-2 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors self-end"
                              title="" data-tooltip="Delete Criteria"  style={{ '--tooltip-bg': 'black' }}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          )}
                        </div>
                         {/* Date Range Section */}
<div className="mb-4">
  <label className="block text-sm font-medium text-gray-700 mb-2">
    Date Range
  </label>
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        From Date
      </label>
      <div className="flex gap-2">
        {/* Text input for typing */}
        <input
          type="text"
          className="flex-1 border border-gray-300 p-1 rounded-md focus:ring-2 focus:ring-[#0f4392] focus:border-[#0f4392] outline-none"
          value={criteria.fromDate}
          onChange={(e) => handleDateInput(criteria.id, 'from', e.target.value, false)}
          placeholder="DD/MM/YYYY"
          maxLength="10"
          title="Enter date in DD/MM/YYYY format"
        />
        {/* Calendar picker button - working version */}
        <div className="relative">
          <input
            type="date"
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            value={formatDateForInput(criteria.fromDate)}
            onChange={(e) => handleDateInput(criteria.id, 'from', e.target.value, true)}
            title="Select date from calendar"
            style={{ zIndex: 10 }}
          />
          <div className="p-2 border border-gray-300 rounded-md bg-gray-50 hover:bg-gray-100 transition-colors flex items-center justify-center pointer-events-none">
            <svg className="w-4 h-4 text-gray-600" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
            </svg>
          </div>
        </div>
      </div>
      {/* Helper text */}
{/*       <p className="text-xs text-gray-500 mt-1">
        Type date (DD/MM/YYYY) or click calendar button
      </p> */}
      {/* Validation for invalid date format */}
      {criteria.fromDate && criteria.fromDate.length === 10 && !formatDateForInput(criteria.fromDate) && (
        <p className="text-xs text-red-500 mt-1">
          Please enter a valid date (DD/MM/YYYY)
        </p>
      )}
    </div>
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        To Date
      </label>
      <div className="flex gap-2">
        {/* Text input for typing */}
        <input
          type="text"
          className="flex-1 border border-gray-300 p-1 rounded-md focus:ring-2 focus:ring-[#0f4392] focus:border-[#0f4392] outline-none"
          value={criteria.toDate}
          onChange={(e) => handleDateInput(criteria.id, 'to', e.target.value, false)}
          placeholder="DD/MM/YYYY"
          maxLength="10"
          title="Enter date in DD/MM/YYYY format"
        />
        {/* Calendar picker button - working version */}
        <div className="relative">
          <input
            type="date"
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            value={formatDateForInput(criteria.toDate)}
            onChange={(e) => handleDateInput(criteria.id, 'to', e.target.value, true)}
            min={formatDateForInput(criteria.fromDate)}
            title="Select date from calendar"
            style={{ zIndex: 10 }}
          />
          <div className="p-2 border border-gray-300 rounded-md bg-gray-50 hover:bg-gray-100 transition-colors flex items-center justify-center pointer-events-none">
            <svg className="w-4 h-4 text-gray-600" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
            </svg>
          </div>
        </div>
      </div>
      {/* Helper text */}
      {/* <p className="text-xs text-gray-500 mt-1">
        Type date (DD/MM/YYYY) or click calendar button
      </p> */}
      {/* Validation messages */}
      {criteria.toDate && criteria.toDate.length === 10 && !formatDateForInput(criteria.toDate) && (
        <p className="text-xs text-red-500 mt-1">
          Please enter a valid date (DD/MM/YYYY)
        </p>
      )}
      {criteria.fromDate && criteria.toDate && 
       formatDateForInput(criteria.fromDate) && formatDateForInput(criteria.toDate) &&
       formatDateForInput(criteria.toDate) < formatDateForInput(criteria.fromDate) && (
        <p className="text-xs text-red-500 mt-1">
          To date must be after from date
        </p>
      )}
    </div>
  </div>
</div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Conditions
                          </label>
                          {renderConditions(
                            criteria.conditions,
                            updateRewardCriteriaCondition,
                            removeRewardCriteriaCondition,
                            criteria.id,
                            addRewardCriteriaCondition
                          )}
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Reward Rules */}
<div className="bg-white rounded-lg border border-gray-300 p-6">
  <div className="flex justify-between items-center mb-2">
    <h2 className="text-lg font-semibold">How many coins can be given?(Reward)</h2>
    <button
      onClick={addRewardRule}
      className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md transition-colors"
      title="" data-tooltip="Add Reward Rule"  style={{ '--tooltip-bg': 'black' }}
    >
      +
    </button>
  </div>
  {rewardRules.map((rule) => (
    <div key={rule.id} className="mb-6 p-4 border border-gray-200 rounded-lg">
      <div className="flex justify-between items-center mb-4">
        <div className="flex-1 mr-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Rule Name
          </label>
          <input
            className="w-full border border-gray-300 p-1 rounded-md focus:ring-2 focus:ring-[#0f4392] focus:border-[#0f4392] outline-none"
            value={rule.name || generateRewardRuleName(rule)}
            onChange={(e) => updateRewardRule(rule.id, "name", e.target.value)}
            placeholder="Enter rule name or leave blank for auto-generation"
          />
        </div>
        {rewardRules.length > 1 && (
          <button
            onClick={() => removeRewardRule(rule.id)}
            className="px-2 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors self-end"
            title="" data-tooltip="Delete Reward Rule"  style={{ '--tooltip-bg': 'black' }}
          >
             <FontAwesomeIcon icon={faTrash} />
          </button>
        )}
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Reward Configuration
        </label>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4"> {/* Changed from 4 to 3 columns */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Reward Type
            </label>
            <select
              className="w-full border border-gray-300 p-1 rounded-md"
              value={rule.rewardType}
              onChange={(e) => updateRewardRule(rule.id, "rewardType", e.target.value)}
            >
              <option value="fixed">Fixed</option>
              <option value="percentage">Percentage</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Reward Value
            </label>
            <input
              className="w-full border border-gray-300 p-1 rounded-md"
              type="number"
              placeholder="Reward Value"
              value={rule.rewardValue}
              onChange={(e) => updateRewardRule(rule.id, "rewardValue", e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Limit
            </label>
            <input
              className="w-full border border-gray-300 p-1 rounded-md"
              type="number"
              placeholder="Limit"
              value={rule.limit}
              onChange={(e) => updateRewardRule(rule.id, "limit", e.target.value)}
            />
          </div>
        </div>
        
        {/* Second row with 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Applied On
            </label>
            <select
              className="w-full border border-gray-300 p-1 rounded-md"
              value={rule.applyTarget}
              onChange={(e) => updateRewardRule(rule.id, "applyTarget", e.target.value)}
            >
              {/* <option value="wallet">Wallet</option> */}
              <option value="order">Order</option>
              <option value="item">Item</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Apply To
            </label>
            <select
              className="w-full border border-gray-300 p-1 rounded-md"
              value={rule.destination}
              onChange={(e) => updateRewardRule(rule.id, "destination", e.target.value)}
            >
              <option value="wallet">Wallet</option>
              <option value="immediate">Immediate Order</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Applicable Items
            </label>
            <MultiSelectDropdown
              options={items}
              selectedValues={rule.applicableItems ? 
                rule.applicableItems.map(item => 
                  typeof item === 'object' ? item.id : item
                ).filter(id => id !== "all") : []
              }
              onChange={(selectedValues) => updateRewardRuleApplicableItems(rule.id, selectedValues)}
              placeholder="Select applicable items"
            />
          </div>

        </div>
      </div>
    </div>
  ))}
</div>
</div>
                  {/*Reward Section ends*/}

                  {/*Redemption section start*/}
                  <div className="bg-white border border-gray-300 rounded-lg p-6 space-y-6">

                  {/* Applicability Rules */}
                  <div className="bg-white rounded-lg border border-gray-300 p-6">
                    <div className="flex justify-between items-center mb-2">
                      {/* <h2 className="text-lg font-semibold">Applicability Rules</h2> */}
                      <h2 className="text-lg font-semibold">When/Where these coins can be applied?(Applicability)</h2>
                      <button 
                        onClick={addApplicabilityRule} 
                        className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md transition-colors"
                        title="" data-tooltip="Add Applicability Rule"  style={{ '--tooltip-bg': 'black' }}
                      >
                        +
                      </button>
                    </div>
                    {applicabilityRules.map((rule) => (
                      <div key={rule.id} className="mb-6 p-4 border border-gray-200 rounded-lg">
                        <div className="flex justify-between items-center mb-4">
                          <div className="flex-1 mr-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Rule Name
                            </label>
                            <input
                              className="w-full border border-gray-300 p-1 rounded-md focus:ring-2 focus:ring-[#0f4392] focus:border-[#0f4392] outline-none"
                              value={rule.name || generateApplicabilityRuleName(rule)}
                              onChange={(e) => updateApplicabilityRuleName(rule.id, e.target.value)}
                              placeholder="Enter rule name or leave blank for auto-generation"
                            />
                          </div>
                          {applicabilityRules.length > 1 && (
                            <button 
                              onClick={() => removeApplicabilityRule(rule.id)} 
                              className="px-2 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors self-end"
                              title="" data-tooltip="Delete Applicability Rule"  style={{ '--tooltip-bg': 'black' }}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          )}
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Conditions
                          </label>
                          {renderConditions(
                            rule.conditions,
                            updateApplicabilityCondition,
                            removeApplicabilityCondition,
                            rule.id,
                            addApplicabilityCondition
                          )}
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Updated Redemption Rules */}
                  <div className="bg-white rounded-lg border border-gray-300 p-6">
                    <div className="flex justify-between items-center mb-2">
                      {/* <h2 className="text-lg font-semibold">Redemption Rules</h2> */}
                      <h2 className="text-lg font-semibold">How many coins can be redeemed?(Redemption)</h2>
                      <button 
                        onClick={addRedemptionRule} 
                        className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md transition-colors"
                        title="" data-tooltip="Add Redemption Rule"  style={{ '--tooltip-bg': 'black' }}
                      >
                        +
                      </button>
                    </div>
                    {redemptionRules.map((rule) => (
                      <div key={rule.id} className="mb-6 p-4 border border-gray-200 rounded-lg">
                        <div className="flex justify-between items-center mb-4">
                          <div className="flex-1 mr-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Rule Name
                            </label>
                            <input
                              className="w-full border border-gray-300 p-1 rounded-md focus:ring-2 focus:ring-[#0f4392] focus:border-[#0f4392] outline-none"
                              value={rule.name || generateRedemptionRuleName(rule)}
                              onChange={(e) => updateRedemptionRule(rule.id, "name", e.target.value)}
                              placeholder="Enter rule name or leave blank for auto-generation"
                            />
                          </div>
                          {redemptionRules.length > 1 && (
                            <button 
                              onClick={() => removeRedemptionRule(rule.id)} 
                              className="px-2 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors self-end"
                              title="" data-tooltip="Delete Redemption Rule"  style={{ '--tooltip-bg': 'black' }}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          )}
                        </div>
                        
                        <div className="mb-4">
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Redemption Configuration
                          </label>
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                Redeem Type
                              </label>
                              <select
                                className="w-full border border-gray-300 p-1 rounded-md focus:ring-2 focus:ring-[#0f4392] focus:border-[#0f4392] outline-none"
                                value={rule.redeemType}
                                onChange={(e) => updateRedemptionRule(rule.id, "redeemType", e.target.value)}
                              >
                                <option value="percentage">Percentage</option>
                                <option value="fixed">Fixed</option>
                              </select>
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                Redeem Value
                              </label>
                              <input
                                className="w-full border border-gray-300 p-1 rounded-md focus:ring-2 focus:ring-[#0f4392] focus:border-[#0f4392] outline-none"
                                type="number"
                                placeholder="Enter redeem value"
                                value={rule.redeemValue}
                                onChange={(e) => updateRedemptionRule(rule.id, "redeemValue", e.target.value)}
                              />
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                Apply Target
                              </label>
                              <select
                                className="w-full border border-gray-300 p-1 rounded-md focus:ring-2 focus:ring-[#0f4392] focus:border-[#0f4392] outline-none"
                                value={rule.applyTarget}
                                onChange={(e) => updateRedemptionRule(rule.id, "applyTarget", e.target.value)}
                              >
                                <option value="order">Order Value</option>
                                <option value="item">Item Value</option>
                                <option value="coins">Available Buildcoins</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  </div>
                  {/*Redemption section ends*/}

                  {/* Updated Expiry Rules */}
                  <div className="bg-white rounded-lg border border-gray-300 p-6">
                    <div className="flex justify-between items-center mb-2">
                      {/* <h2 className="text-lg font-semibold">Expiry Rules</h2> */}
                      <h2 className="text-lg font-semibold">Expiry for the coins(Expiry)</h2>
                      <button 
                        onClick={addExpiryRule} 
                        className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md transition-colors"
                        title="" data-tooltip="Add Expiry Rule"  style={{ '--tooltip-bg': 'black' }}
                      >
                        +
                      </button>
                    </div>
                    {expiryRules.map((rule) => (
                      <div key={rule.id} className="mb-6 p-4 border border-gray-200 rounded-lg">
                        <div className="flex justify-between items-center mb-4">
                          <div className="flex-1 mr-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Rule Name
                            </label>
                            <input
                              className="w-full border border-gray-300 p-1 rounded-md focus:ring-2 focus:ring-[#0f4392] focus:border-[#0f4392] outline-none"
                              value={rule.name || generateExpiryRuleName(rule)}
                              onChange={(e) => updateExpiryRule(rule.id, "name", e.target.value)}
                              placeholder="Enter rule name or leave blank for auto-generation"
                            />
                          </div>
                          {expiryRules.length > 1 && (
                            <button 
                              onClick={() => removeExpiryRule(rule.id)} 
                              className="px-2 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors self-end"
                              title="" data-tooltip="Delete Expiry Rule"  style={{ '--tooltip-bg': 'black' }}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          )}
                        </div>
                        
                        <div className="mb-4">
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Expiry Configuration
                          </label>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                Expiry Type
                              </label>
                              <select
                                className="w-full border border-gray-300 p-1 rounded-md focus:ring-2 focus:ring-[#0f4392] focus:border-[#0f4392] outline-none"
                                value={rule.expiryType}
                                onChange={(e) => updateExpiryRule(rule.id, "expiryType", e.target.value)}
                              >
                                <option value="days">Days</option>
                                <option value="months">Months</option>
                                <option value="years">Years</option>
                              </select>
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                Expiry Value
                              </label>
                              <input
                                className="w-full border border-gray-300 p-1 rounded-md focus:ring-2 focus:ring-[#0f4392] focus:border-[#0f4392] outline-none"
                                type="number"
                                placeholder="Enter expiry value"
                                value={rule.expiryValue}
                                onChange={(e) => updateExpiryRule(rule.id, "expiryValue", e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Conditions
                          </label>
                          {renderConditions(
                            rule.conditions,
                            updateExpiryCondition,
                            removeExpiryCondition,
                            rule.id,
                            addExpiryCondition
                          )}
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Generated Rule JSON */}
{/*                   <div className="bg-white rounded-lg shadow-lg p-6">
                    <h2 className="text-lg font-semibold mb-4">Generated Rule JSON</h2>
                    <pre className="bg-gray-100 p-4 rounded-lg overflow-auto text-sm max-h-96 border">
                      {JSON.stringify(buildRule(), null, 2)}
                    </pre>
                    <div className="mt-4 flex gap-4">
                      <button 
                        onClick={() => navigator.clipboard.writeText(JSON.stringify(buildRule(), null, 2))}
                        className="px-2 py-1 bg-[#0f4392] text-white rounded-md transition-colors"
                      >
                        Copy JSON
                      </button>
                      <button 
                        onClick={() => {
                          const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(buildRule(), null, 2));
                          const downloadAnchorNode = document.createElement('a');
                          downloadAnchorNode.setAttribute("href", dataStr);
                          downloadAnchorNode.setAttribute("download", "rules.json");
                          document.body.appendChild(downloadAnchorNode);
                          downloadAnchorNode.click();
                          downloadAnchorNode.remove();
                        }}
                        className="px-2 py-1 bg-[#E9001E] text-white rounded-md transition-colors"
                      >
                        Download JSON
                      </button>
                      <button 
                        onClick={saveRulesToSession}
                        className="px-2 py-1 bg-[#28a745] text-white rounded-md transition-colors"
                      >
                        Save to Session
                      </button>
                    </div>
                  </div> */}
                </div>
              </div>
              
      <div className="flex-shrink-0 w-full border-t bg-white">
        <div className="flex justify-start items-end space-x-2 px-6 py-4">
          <button
            className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md inline-flex items-center"
            onClick={() => handleSubmit()}
            disabled={isSaving}
          >
            <span>Update</span>
            {isSaving && <Spinner />}
          </button>
          <button
            className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
              isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
            }`}
            disabled={isSaving}
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
    </div>

    {/* Cancel Confirmation Popup */}
    {showCancelPopup && (
      <div className="fixed inset-0 bg-gray-500/50 flex justify-center items-center z-50">
        <div className="bg-white rounded shadow-md p-8 max-w-md">
          <h2 className="text-lg font-bold text-center mb-4">Unsaved Changes</h2>
          <p className="text-gray-600 text-center mb-6">You have unsaved changes. Are you sure you want to leave?</p>
          <div className="flex justify-center gap-4">
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
              onClick={() => {
                setShowCancelPopup(false);
                navigate(-1);
              }}
            >
              Leave
            </button>
            <button
              className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
              onClick={() => setShowCancelPopup(false)}
            >
              Stay
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
  );
}
